import React from 'react';
import Hero from '../components/Hero';
import WeatherSection from '../components/WeatherSection';
import DrivingSection from '../components/DrivingSection';
import SitePartner from '../components/SitePartner';
import ShareSection from '../components/ShareSection';

const PrinceCounty = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-10">
      <Hero 
        title="Prince County" 
        subtitle="Western Prince Edward Island"
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773310180/prince_zjtnqt.jpg"
      />
      <div className="max-w-2xl mx-auto px-4 mt-6">
        <SitePartner />
        <div className="flex flex-col gap-8 mt-4">
          <WeatherSection 
            title="Summerside Weather" 
            delay={0.1} 
            headerClassName="bg-purple-800 text-white"
            link="https://weather.gc.ca/en/location/index.html?coords=46.393,-63.789"
            buttonText="Today's Prince County Weather"
            imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773315930/summerside_rbv0vi.jpg"
          />
          <DrivingSection 
            title="Prince County Driving Conditions" 
            delay={0.2} 
            headerClassName="bg-orange-500 text-white"
            imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773272098/Driving_c1vsow.png"
            link="https://511.gov.pe.ca/roadconditions?filters%5B0%5D%5Bs%5D=Prince+County"
            buttonText="Check Live Prince County Driving conditions"
          />
        </div>
        <ShareSection />
      </div>
    </div>
  );
};

export default PrinceCounty;